import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Typography } from "@mui/material";

import { findGetParameter } from "../../components/utilities/UtilityFunctions";

import RankingsWidget from "../../components/rankings/RankingsWidget";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { handlePagingAll } from "../../components/api/APIUtilities";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function OrganizationTruncatedRankings(props) {
  const { appRoute } = props;
  const embed = appRoute || findGetParameter("embed") === "true";

  let { organizationId } = useParams();

  const [loading, setLoading] = useState(true);
  const [rankingGroups, setRankingGroups] = useState(null);

  useEffect(() => {
    const go = async () => {
      let queryParams = {
        gameStoreId: organizationId,
        active: true,
        "expand[]": ["gameSystem"],
      };
      if (getEnvironmentVariable("SINGLE_GAME_SYSTEM")) {
        queryParams.gameSystemId = getEnvironmentVariable("SINGLE_GAME_SYSTEM");
      } else if (getEnvironmentVariable("SINGLE_GAME_TYPE")) {
        queryParams.gameType = getEnvironmentVariable("SINGLE_GAME_TYPE");
      } else if (getEnvironmentVariable("SINGLE_GAME_MANUFACTURER")) {
        queryParams.gameSystemManufacturer = getEnvironmentVariable(
          "SINGLE_GAME_MANUFACTURER"
        );
      }
      var apiData = await handlePagingAll("/leagues", queryParams);

      apiData.sort((a, b) => {
        if (
          a.gameSystem?.manufacturerOrderNum ||
          b.gameSystem?.manufacturerOrderNum
        ) {
          if (!a.gameSystem?.manufacturerOrderNum) return -1;
          if (!b.gameSystem?.manufacturerOrderNum) return 1;
          if (
            a.gameSystem?.manufacturerOrderNum !==
            b.gameSystem?.manufacturerOrderNum
          ) {
            return (
              a.gameSystem?.manufacturerOrderNum -
              b.gameSystem?.manufacturerOrderNum
            );
          }
        }
        if (
          a.gameSystem?.gameSystemOrderNum ||
          b.gameSystem?.gameSystemOrderNum
        ) {
          if (!a.gameSystem?.gameSystemOrderNum) return -1;
          if (!b.gameSystem?.gameSystemOrderNum) return 1;
          if (
            a.gameSystem?.gameSystemOrderNum !==
            b.gameSystem?.gameSystemOrderNum
          ) {
            return (
              a.gameSystem?.gameSystemOrderNum -
              b.gameSystem?.gameSystemOrderNum
            );
          }
        }

        if (!a.name && !b.name) return 0;
        if (!a.name) return -1;
        if (!b.name) return 1;

        var aVal = a.name.toUpperCase();
        var bVal = b.name.toUpperCase();

        if (aVal < bVal) return -1;
        if (aVal > bVal) return 1;
        return 0;
      });

      apiData.forEach((rankingGroup) => {
        if (!rankingGroup.topX) rankingGroup.topX = 5;
      });

      setRankingGroups(apiData);
      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading && <ModalLoadingFull />}
      {!loading && rankingGroups && rankingGroups.length > 0 && (
        <Container sx={{ pt: 2, pb: 2, textAlign: "center" }} maxWidth="lg">
          <Typography variant="h1" gutterBottom>
            Rankings
          </Typography>

          <RankingsWidget rankingGroups={rankingGroups} embed={embed} />
        </Container>
      )}
      {!loading && rankingGroups && rankingGroups.length === 0 && (
        <Container maxWidth="lg" sx={{ pt: 2, pb: 2 }}>
          <Typography variant="h1" gutterBottom>
            Coming Soon
          </Typography>
        </Container>
      )}
    </>
  );
}
